export enum TypeOfferEnum {
  CP = 'CP',
  C = 'C',
  P = 'P',
  S = 'S'
}
